const comps = [
  {
    type: "user-select",
    label: "人员选择",
    field: ["Type", "UserId", "Remark"],
    value: "{0}_{1}",
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "institution-select",
    label: "机构组织",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  // {
  //   type: "institution-select",
  //   label: "组织名称",
  //   field: ["Type", "SocialId", "Name"],
  //   fieldName: "Organization",
  //   valueNumber: 2,
  //   category: 2,
  //   count: 5
  // },
  {
    type: "maintenance-select",
    label: "故障类型",
    field: ["SocialId", "Type", "ObjFaultName"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "maintenance-select",
    label: "故障类型",
    field: ["SocialId", "Type", "ObjFaultName"],
    fieldName: "FaultType",
    valueNumber: 2,
    category: 2,
    count: 5
  },
  {
    type: "maintenance-object-select",
    label: "运维对象",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "apply-select",
    label: "所属应用",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "blade-server-select",
    label: "交换机",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "exchange-board-select",
    label: "操作系统",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "operating-system-select",
    label: "服务器",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "server-select",
    label: "刀片服务器",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "service-select",
    label: "服务",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  // {
  //   type: "receiver-select",
  //   label: "接收方",
  //   field: ["Key", "Name"],
  //   valueNumber: 1,
  //   category: 1,
  //   count: 5
  // },
  {
    type: "team-select",
    label: "团队",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 1,
    category: 1,
    count: 5
  },
  {
    type: "application-classify-select",
    label: "应用分组",
    field: ["ClassifyId", "ClassifySource", "ClassifyName"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "application-level-select",
    field: ["value", "label"],
    valueNumber: 1,
    label: "应用安全等级",
    category: 1,
    count: 5
  },
  {
    type: "application-mode-select",
    field: ["value", "label"],
    valueNumber: 1,
    label: "应用模式",
    category: 1,
    count: 5
  },
  {
    type: "apply-category-select",
    label: "应用类别",
    field: ["value", "label"],
    valueNumber: 1,
    category: 1,
    count: 5
  },
  {
    type: "device-state-select",
    label: "设备状态",
    // valueNumber: 0,
    category: 1,
    count: 5
  },
  // {
  //   type: "device-type-select",
  //   label: "设备类型",
  //   count: 5
  // },
  {
    type: "disk-add",
    label: "添加磁盘",
    category: 1,
    count: 5
  },
  {
    type: "importance-select",
    label: "重要程度",
    field: ["value", "label"],
    valueNumber: 1,
    category: 1,
    count: 5
  },
  {
    type: "ip-and-mac-select",
    label: "IPMAC(待完善)",
    category: 1,
    count: 5
  },
  {
    type: "ip-select",
    label: "IP(待完善)",
    category: 1,
    count: 5
  },
  {
    type: "mac-select",
    label: "MAC(待完善)",
    category: 1,
    count: 5
  },
  {
    type: "manufacturer-select",
    label: "厂商",
    field: ["ID", "Name"],
    valueNumber: 1,
    category: 1,
    count: 5
  },
  {
    type: "security-attributes-select",
    label: "安全属性",
    field: ["value", "label"],
    valueNumber: 1,
    category: 1,
    count: 5
  },
  {
    type: "service-category-select",
    label: "服务分组",
    field: ["ObjTypeCode", "ObjCodeName"],
    valueNumber: 1,
    category: 1,
    count: 5
  },
  {
    type: "system-classify-select",
    label: "系统类别",
    field: ["ObjTypeCode", "ObjCodeName"],
    valueNumber: 1,
    category: 1,
    count: 5
  },
  {
    type: "address-select",
    label: "故障地址",
    field: ["value", "value"],
    fieldName: "FaultAddress",
    valueNumber: 1,
    category: 2,
    count: 5
  },
  {
    type: "address-select",
    label: "物理位置",
    field: ["value", "value"],
    valueNumber: 1,
    category: 1,
    count: 5
  },
  {
    type: "department-select",
    label: "创建科室",
    field: ["ID"],
    fieldName: "CreateDepartment",
    category: 2,
    count: 5
  },
  {
    type: "device-list",
    label: "选择设备",
    field: ["Type", "SocialId", "Name"],
    fieldName: "DoneDevice",
    valueNumber: 1,
    category: 2,
    count: 5
  },
  {
    type: "device-list",
    label: "选择设备",
    field: ["Type", "SocialId", "Name"],
    valueNumber: 2,
    category: 1,
    count: 5
  },
  {
    type: "task-level-select",
    label: "任务等级",
    field: ["value", "label"],
    fieldName: "TaskLevel",
    isHideDeleteBtn: true,
    valueNumber: 1,
    category: 2,
    count: 5
  },
  {
    type: "focus-level-select",
    label: "关注度",
    field: ["value", "label"],
    fieldName: "FocusLevel",
    isHideDeleteBtn: true,
    valueNumber: 1,
    category: 2,
    count: 5
  },
  {
    type: "task-group-select",
    label: "任务组",
    field: ["id", "label"],
    fieldName: "TaskGroup",
    valueNumber: 1,
    category: 2,
    count: 5
  },
  // {
  //   type: "time-interval",
  //   label: "任务时长",
  //   fieldName: "TaskTimeInterval",
  //   category: 2,
  //   count: 5
  // },
  // {
  //   type: "time-interval-unit",
  //   label: "任务时长单位",
  //   fieldName: "TaskTimeIntervalUnit",
  //   isShowLabel: false,
  //   category: 2,
  //   count: 5
  // },
  // {
  //   type: "system-classify-special-select",
  //   label: "系统分组",
  //   count: 5
  // },
  // {
  //   type: "system-model-select",
  //   label: "系统型号",
  //   count: 5
  // },
  {
    type: "input",
    label: "单行输入框",
    category: 1,
    count: 4
  },
  {
    type: "textarea",
    label: "多行输入框",
    category: 1,
    count: 4
  },
  {
    type: "editor",
    label: "富文本编辑器",
    isExtend: true,
    category: 1,
    count: 4
  },
  {
    type: "select",
    label: "选择器",
    field: ["value", "text"],
    valueNumber: 1,
    category: 1,
    count: 4
  },
  {
    type: "number",
    label: "数字",
    category: 1,
    count: 3
  },
  {
    type: "checkbox",
    label: "复选",
    field: ["value", "text"],
    valueNumber: 1,
    category: 1,
    count: 3
  },
  {
    type: "radio",
    label: "单选",
    field: ["value", "text"],
    valueNumber: 1,
    category: 1,
    count: 3
  },
  {
    type: "switch",
    label: "开关",
    category: 1,
    count: 2
  },
  // {
  //   type: "image-uploader",
  //   label: "上传图片",
  //   isExtend: true,
  //   category: 1,
  //   count: 2
  // },
  {
    type: "date",
    label: "日期",
    category: 1,
    count: 2
  },
  {
    type: "daterange",
    label: "日期范围",
    category: 1,
    count: 2
  },
  {
    type: "datetime",
    label: "时间和日期",
    category: 1,
    count: 2
  },
  {
    type: "datetimerange",
    label: "日期和时间范围",
    category: 1,
    count: 2
  },
  // {
  //   type: "time",
  //   label: "时间",
  //   category: 1,
  //   count: 2
  // },
  // {
  //   type: "timerange",
  //   label: "时间范围",
  //   category: 1,
  //   count: 2
  // },
  // {
  //   type: "dates",
  //   label: "多日期",
  //   category: 1,
  //   count: 2
  // },
  // {
  //   type: "week",
  //   label: "周",
  //   category: 1,
  //   count: 2
  // },
  // {
  //   type: "month",
  //   label: "月",
  //   category: 1,
  //   count: 2
  // },
  // {
  //   type: "monthrange",
  //   label: "月范围",
  //   category: 1,
  //   count: 2
  // },
  // {
  //   type: "year",
  //   label: "年",
  //   category: 1,
  //   count: 2
  // },
  {
    type: "color",
    label: "颜色选择器",
    category: 1,
    count: 1
  },
  // {
  //   type: "cascader",
  //   label: "级联选择器",
  //   category: 1,
  //   count: 1
  // },
  // {
  //   type: "transfer",
  //   label: "穿梭框",
  //   category: 1,
  //   count: 1
  // },
  // {
  //   type: "cascader-panel",
  //   label: "级联面板",
  //   category: 1,
  //   count: 1
  // },
  {
    type: "password",
    label: "密码框",
    category: 1,
    count: 1
  },
  // {
  //   type: "upload-file",
  //   label: "文件上传",
  //   isExtend: true,
  //   category: 1,
  //   count: 1
  // },
  {
    type: "yesno",
    label: "是否",
    category: 1,
    count: 1
  },
  {
    type: "slider",
    label: "滑块",
    category: 1,
    count: 0
  },
  {
    type: "radio-button",
    label: "单选按钮",
    category: 1,
    count: 0
  },
  {
    type: "checkbox-button",
    label: "复选按钮",
    category: 1,
    count: 0
  },
  {
    type: "autocomplete",
    label: "带建议的输入框",
    category: 1,
    count: 0
  },
  {
    type: "rate",
    label: "评分组件",
    category: 1,
    count: 0
  },
  {
    type: "image",
    label: "图片展示",
    category: 1,
    count: 0
  },
  {
    type: "tag",
    label: "标签",
    category: 1,
    count: 0
  },
  {
    type: "text",
    label: "静态文本",
    category: 1,
    count: 0
  },
  {
    type: "divider",
    label: "分割线",
    category: 1,
    count: 0
  },
  {
    type: "button",
    label: "按钮",
    category: 1,
    count: 0
  },
  // {
  //   type: "video-uploader",
  //   label: "上传视频",
  //   isExtend: true,
  //   category: 1,
  //   count: 0
  // },
  {
    type: "tree-select",
    label: "树形下拉选择器",
    field: ["value", "text"],
    valueNumber: 1,
    isExtend: true,
    category: 1,
    count: 0
  },
  // {
  //   type: "dynamic",
  //   label: "动态组件",
  //   isExtend: true,
  //   category: 1,
  //   count: 0
  // },
  // {
  //   type: "table-editor",
  //   label: "表格编辑组件",
  //   isExtend: true,
  //   category: 1,
  //   count: 0
  // },
  // {
  //   type: "codemirror",
  //   label: "代码编辑器",
  //   isExtend: true,
  //   category: 1,
  //   count: 0
  // },
  // {
  //   type: "json-editor",
  //   label: "JSON编辑器",
  //   isExtend: true,
  //   category: 1,
  //   count: 0
  // },
  // {
  //   type: "markdown-editor",
  //   label: "markdown编辑器",
  //   isExtend: true,
  //   category: 1,
  //   count: 0
  // },
  // {
  //   type: "bmap",
  //   label: "地图",
  //   isExtend: true,
  //   category: 1,
  //   count: 0
  // },
  // {
  //   type: "gallery",
  //   label: "图片及视频展示",
  //   isExtend: true,
  //   category: 1,
  //   count: 0
  // },
  /*****套件使用 */
  {
    label: "预计开始时间",
    type: "estimated-start-time",
    isExtend: true,
    fieldName: "EstimatedStartTime",
    category: 2,
    count: 5
  },
  {
    label: "预计完成时间",
    type: "estimated-time",
    isExtend: true,
    field: ["time", "isNotice"],
    valueNumber: 2,
    fieldName: "EstimatedTime",
    category: 2,
    count: 5
  },
  {
    label: "接收时长",
    type: "receive-time",
    isExtend: true,
    field: ["time", "value", "text"],
    valueNumber: 2,
    fieldName: "ReceiveTime",
    category: 2,
    count: 5
  },
  {
    label: "逾期提醒周期",
    type: "overdue-reminder",
    isExtend: true,
    field: ["time", "value", "text"],
    valueNumber: 2,
    fieldName: "OverdueReminder",
    category: 2,
    count: 5
  },
  {
    label: "标题",
    type: "task-title",
    isExtend: true,
    field: ["time", "tag"],
    valueNumber: 2,
    fieldName: "TaskTitle",
    category: 2,
    isHideDeleteBtn: true,
    count: 5
  },
  {
    label: "内容描述",
    type: "task-content",
    isExtend: true,
    field: ["content", "needreply"],
    valueNumber: 2,
    fieldName: "TaskContent",
    category: 2,
    count: 5
  },
  {
    label: "干系人",
    type: "stakeholder",
    isExtend: true,
    // field: ["Type", "UserId", "Remark"],
    field: ["USERTYPE", "USERID", "USERNAME"],
    valueNumber: 2,
    fieldName: "StakeholderUser",
    category: 2,
    count: 5
  },
  {
    label: "联系人",
    type: "link-user",
    isExtend: true,
    field: ["Type", "UserId", "Remark"],
    valueNumber: 2,
    fieldName: "LinkUser",
    category: 2,
    count: 5
  },
  {
    type: "receiver-select",
    label: "接收方",
    isExtend: true,
    field: ["Key", "Name"],
    fieldName: "Receiver",
    valueNumber: 1,
    category: 2,
    count: 5
  },
  {
    type: "patient-table-editor",
    label: "患者信息",
    fieldName: "Patient",
    isExtend: true,
    category: 3,
    count: 0
  },
  {
    type: "personnel-dispatch-table",
    label: "人员调度",
    fieldName: "PersonnelDispatch",
    isExtend: true,
    category: 3,
    count: 0
  },
  {
    type: "material-dispatch-table",
    label: "物资调度",
    fieldName: "MaterialDispatch",
    isExtend: true,
    category: 3,
    count: 0
  }
];

export default comps;
